<script setup>
// §8.2 StatRow — 2–4 metrics, vertical hairline separators, tabular-nums.
// Metric numerals are Inter 22–26/600 tabular (§5). Pass items as
// [{ label, value, sub? }]. Values render in a tabular column.
defineProps({
  items: { type: Array, required: true }, // [{ label, value, sub }]
})
</script>

<template>
  <div class="l-statrow">
    <div v-for="(it, i) in items" :key="i" class="stat">
      <div class="metric num">{{ it.value }}</div>
      <div class="lbl">{{ it.label }}</div>
      <div v-if="it.sub" class="sub">{{ it.sub }}</div>
    </div>
  </div>
</template>

<style scoped>
.l-statrow {
  display: flex;
  align-items: stretch;
}
.stat {
  flex: 1;
  padding: 0 var(--sp-5);
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.stat:first-child {
  padding-left: 0;
}
.stat + .stat {
  border-left: 1px solid var(--line-soft);
}
.metric {
  font-size: var(--text-metric);
  font-weight: 600;
  color: var(--text);
  line-height: 1.1;
}
.lbl {
  font-size: var(--text-chip);
  font-weight: 600;
  color: var(--text-2);
}
.sub {
  font-size: var(--text-chip);
  color: var(--text-3);
}
</style>
